module.exports = __webpack_public_path__ + "dashboard/img/warning.27cbed8a26736564f59430b6c168eacf.svg";